import ReactDOM from "react-dom/client";
import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/styles/tailwind.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Auth from "./layouts/Auth";
import Admin from "./layouts/Admin";
import { Toaster } from "sonner";
import OrderLists from "./layouts/OrderLists";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import OrderTrackingInfo from "./layouts/OrderTrackingInfo";
import BankDetails from "./layouts/BankDetails";
import { ConfigProvider } from "antd";

const theme = {
  token: {
    colorPrimary: "#3d5939",        
    colorPrimaryHover: "#4d6f48",   // lighter green
    colorPrimaryActive: "#2f442b",  // darker green
    colorSuccess: "#4caf50",        // success state
    colorWarning: "#e0a100",        // warning state
    colorError: "#d64545",          // error state
    colorInfo: "#2f80ed",           // info/links
    borderRadius: 8,
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  components: {
    Button: {
      borderRadius: 8,
    },
    Card: {
      borderRadius: 12,
    },
    Input: {
      borderRadius: 8,
    },
    Select: {
      borderRadius: 8,
    },
  },
};


const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

root.render(
  <>
    <ConfigProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter
          basename="/strchstellar_frontend/app"
          future={{ v7_relativeSplatPath: true }}
        >
          <Routes>
            <Route path="/admin/*" element={<Admin />} />
            <Route path="/auth/*" element={<Auth />} />
            <Route path="/order-lists" element={<OrderLists />} />
            <Route
              path="/orders/tracking/:orderNumber?"
              element={<OrderTrackingInfo />}
            />
            <Route
              path="/orders/update-bank-details/:refundId"
              element={<BankDetails />}
            />
            <Route path="/" element={<Navigate to="/auth/login" />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </ConfigProvider>
    <Toaster
      position="top-right"
      duration={3000}
      richColors
      toastOptions={{
        style: {
          background: "#eae6f3",
          boxShadow: "1px 1px 8px 8px rgba(115, 92, 173, 0.12)",
          border: "1px solid rgb(115, 92, 173)",
        },
      }}
    />
  </>
);

reportWebVitals();
